import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const Skelet = (props)=>{
 return(
    <Skeleton className="loader" />
 )   
}
export default Skelet